import { createEnquiryTicket } from 'api/hubspot';
import Label from 'components/Label/Label';
import Modal from 'components/Modal/Modal';
import { Cars, EnquiryTicket } from 'data/types';
import { useEffect, useState } from 'react'
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import Input from 'shared/Input/Input';
import Textarea from 'shared/Textarea/Textarea';

interface Props {
    carData: Cars
    showPopup: boolean
    onClose: () => void
    asModal?: boolean
}

const EnquirePopUp: React.FC<Props> = ({
    carData,
    showPopup = false,
    onClose = () => { },
    asModal = true
}) => {
    useEffect(() => {
        if (!carData.make || !carData.model) return;

        setFormData({
            ...formData,
            message: `Hi, I am interested in your ${carData.make} ${carData.model} for sale. Please contact me with more details.`,
            vehicleDetails: `${carData.make} ${carData.model}`,
            vehicleId: carData.meta.carId,
            url: window.location.href
        })
    }, [carData])

    const [closePopup, setClosePopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState<EnquiryTicket>({
        name: "",
        email: "",
        message: "",
        vehicleId: "",
        vehicleDetails: "",
        contactPhone: "",
    });

    const handleSubmit = async () => {
        if (!formData.name || !formData.email || !formData.message || !formData.contactPhone) {
            alert("Please fill all the fields");
            return;
        }

        if (formData.name.split(" ").length < 2) {
            alert("Please enter your full name");
            return;
        }

        if (!formData.email.includes("@")) {
            alert("Please enter a valid email");
            return;
        }

        if (formData.contactPhone.length < 10) {
            alert("Please enter a valid phone number");
            return;
        }

        setLoading(true);

        try {
            const ticket = await createEnquiryTicket(formData);
            if (ticket) {
                alert("Your enquiry has been submitted successfully");
                setClosePopup(true);
            }
        } catch (err) {
            alert("Something went wrong. Please try again later");
            console.log(err);
        }

        setLoading(false);

        onClose && onClose();
        setClosePopup(true);
    }

    const renderPopup = () => {
        return (
            <div className="flex flex-col items-center justify-center h-full w-full">
                <div className="grid grid-cols-1 gap-6 w-full" id="enquiryForm" role='form'>
                    <label className="block">
                        <Label className='dark:text-white'>Full name</Label>

                        <Input
                            placeholder="Enter your name"
                            type="text"
                            className="mt-2"
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                    </label>
                    <label className="block">
                        <Label className='dark:text-white'>Email address</Label>

                        <Input
                            type="email"
                            placeholder="Enter your email"
                            className="mt-2"
                            autoComplete='email'
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        />
                    </label>
                    <label className="block">
                        <Label className='dark:text-white'>Contact Phone</Label>

                        <Input
                            type="tel"
                            placeholder="Enter your phone number"
                            className="mt-2"
                            autoComplete='tel'
                            onChange={(e) => setFormData({ ...formData, contactPhone: e.target.value })}
                        />
                    </label>
                    <label className="block">
                        <Label className='dark:text-white'>Message</Label>

                        <Textarea
                            className="mt-2" rows={6}
                            name='message'
                            placeholder="Enter your message"
                            defaultValue={formData.message}
                            onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                        />
                    </label>
                    <div>
                        <ButtonPrimary
                            type="submit"
                            className="font-display !text-xs"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Submit Enquiry
                        </ButtonPrimary>
                    </div>
                </div>
            </div>
        );
    }

    if (!asModal) {
        return (
            <div className="flex flex-col h-full w-full px-6" id='enquire'>
                <h1 className="text-lg font-bold text-left my-2 text-red-500 uppercase mb-10">Enquire</h1>

                {renderPopup()}
            </div>
        )
    }

    return showPopup ? (
        <Modal showAfter={0} closeModal={closePopup} dialogTitle="Enquiry">
            <div className="flex flex-col items-center justify-center h-auto w-full">
                {renderPopup()}
            </div>
        </Modal>
    ) : null
}

export default EnquirePopUp;